import { render, staticRenderFns } from "./OrderBinding.vue?vue&type=template&id=fe054cb0&scoped=true"
import script from "./OrderBinding.vue?vue&type=script&lang=js"
export * from "./OrderBinding.vue?vue&type=script&lang=js"
import style0 from "./OrderBinding.vue?vue&type=style&index=0&id=fe054cb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe054cb0",
  null
  
)

export default component.exports